<template>
	<v-card outlined>
		<v-card-title>
			{{ $vuetify.lang.t("$vuetify.views.profile.groups") }}
		</v-card-title>
		<v-card-text>
			<div class="grey--text">
				{{
					$route.params.userID === $store.state.auth.user.id
						? $vuetify.lang.t("$vuetify.views.profile.myGroups")
						: $vuetify.lang.t("$vuetify.views.profile.publicGroups")
				}}
			</div>
			<div v-if="isLoading" class="mt-5">
				<v-skeleton-loader

					v-for="i in 5"
					:key="i"
					type="paragraph"
					class="mb-5"
				></v-skeleton-loader>
			</div>
			<v-row
				v-else
				dense
				justify="space-between"
				no-gutters
				class="mt-2"
			>
				<div
					v-for="group in groups"
					:key="group.id"
					class="d-flex align-center mb-6 w-100"
				>
					<v-avatar class="mr-2" size="36">
						<v-img
							max-height="36"
							max-width="36"
							v-if="group.avatar"
							:src="group.avatar.url"
						/>
						<v-img
							max-height="36"
							max-width="36"
							v-else
							src="@/assets/images/sou-group-av.png"
						/>
					</v-avatar>
					<div class="mr-auto">
						<div
							class="font-weight-bold grey--text text--darken-1"
						>
							{{ group.name }}
						</div>
						<span class="grey--text"
							>{{ group.users_count }}
						</span>
						<span class="grey--text">
							{{
								$vuetify.lang.t(
									"$vuetify.views.profile.groupCount"
								)
							}}
						</span>
					</div>
					<router-link :to="{ path: `/group/${group.id}` }">
						<v-btn class="mr-2" height="32" elevation="0">
							{{
								$vuetify.lang.t(
									"$vuetify.views.profile.goThrough"
								)
							}}
						</v-btn>
					</router-link>
				</div>
			</v-row>
			<v-pagination
				:length="length"
				:total-visible="totalPages"
				@change="changePage()"
				@input="changePage()"
				color="primary"
				v-model="page"
			>
			</v-pagination>
		</v-card-text>
	</v-card>
</template>

<script>
import axios from "axios";

export default {
	props: {
		userID: { type: Number },
	},

	data() {
		return {
			page: 1,
			totalPages: 5,
			perPage: 4,
			groups: [],
			isLoading: true,
			length: 5,
		};
	},

	methods: {
		async getGropus() {
			this.isLoading = true;
			await axios
				.get(`groups/user-groups/${this.userID}`, {
					params: {
						per_page: this.perPage,
						page: this.page,
					},
				})
				.then((response) => {
					this.length = response.data.meta.last_page;
					this.groups = response.data.data;
				})
				.catch((error) => {
					console.log("GET USER GROUPS ERROR", error);
				})
				.finally(() => {
					this.isLoading = false;
				});
		},

		changePage() {
			this.getGropus();
		},
	},

	created() {
		this.getGropus();
	},
};
</script>

<style scoped>
.title-font {
	font-size: 16px;
}
</style>
